const NotFoundPage = () => {
  return <div>Error Page Not Found.</div>
}

export default NotFoundPage
